<script>
import { QNImageUtil } from '@/utils'

export default {
  name: 'MatchInfo',
  props: {
    matchTopInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    bannerUrl() {
      const v = this.matchTopInfo.backgroundImage2
      if (!v) return ''
      return QNImageUtil.imageView(v)
    },
    displayPV() {
      const v = this.matchTopInfo.totalPV
      if (v == null || v === '') return ''
      if (typeof v === 'string') {
        const s = v.trim()
        if (!s) return ''
        if (/万/.test(s)) return s
        const n = Number(s)
        if (!Number.isFinite(n) || n <= 0) return s
        return this.formatPVNumber(n)
      }
      const n = Number(v)
      if (!Number.isFinite(n) || n <= 0) return ''
      return this.formatPVNumber(n)
    }
  },
  methods: {
    formatPVNumber(n) {
      if (n >= 10000) {
        const wan = n / 10000
        const text = wan % 1 === 0 ? String(wan) : wan.toFixed(1).replace(/\.0$/, '')
        return text + '万'
      }
      return String(n)
    }
  }
}
</script>

<template>
  <div class="match-info">
    <div v-if="bannerUrl" class="match-info__banner">
      <img class="match-info__banner-img" :src="bannerUrl" alt="">
    </div>
    <div class="match-info__body">
      <div class="match-info__title">{{ matchTopInfo.name }}</div>
      <div v-if="matchTopInfo.address || displayPV" class="match-info__meta">
        <span v-if="matchTopInfo.address" class="match-info__tag">{{ matchTopInfo.address }}</span>
        <span v-if="displayPV" class="match-info__tag">
          <van-icon name="eye-o" class="match-info__tag-icon" />
          {{ displayPV }}
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.match-info {
  background: #fff;
}

.match-info__banner {
  width: 100%;
  overflow: hidden;
  font-size: 0;
  line-height: 0;
}

.match-info__banner-img {
  display: block;
  width: 100%;
  height: auto;
}

.match-info__body {
  padding: 14px 16px 12px;
  box-sizing: border-box;
}

.match-info__title {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  word-break: break-word;
}

.match-info__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 10px;
  margin-right: -8px;
  margin-bottom: -8px;
}

.match-info__tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  background: #f2f2f2;
  color: #999;
  font-size: 12px;
  line-height: 1.2;
  margin-right: 8px;
  margin-bottom: 8px;
}

.match-info__tag-icon {
  font-size: 13px;
  color: #999;
  margin-right: 4px;
}
</style>
